module.exports = __webpack_public_path__ + "static/media/CompareView.6a351260.svg";